var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var baseUrl = 'https://api.plaudy.com/v1';
window.userId = null;
window.objectId = null;
window.apiKey = null;

exports.init = function () {
  var apiKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  window.apiKey = apiKey;
};

exports.identify = function (user_id, object_id) {
  window.userId = user_id;
  window.objectId = object_id;
  return true;
};

exports.track = function (eventType) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!window.apiKey) {
    retryTrack(eventType, data);
    return false;
  }

  if (!eventType || typeof eventType === 'object') {
    return "Expected string 'eventType' as first argument.";
  }

  var request = {};
  request.type = eventType; // VALUE

  if (data.hasOwnProperty('count')) {
    request.value = data.count;
    delete data.count;
  } // WORKSPACE ID


  request.apiKey = window.apiKey; // USER ID (TRACKED USER)

  if (window.userId && !data.hasOwnProperty('user_id')) {
    request.trackedUser = window.userId;
  } else if (data.hasOwnProperty('user_id')) {
    request.trackedUser = data.user_id;
    delete data.user_id;
  } // OBJECT ID


  if (window.objectId && !data.hasOwnProperty('object_id')) {
    request.objectId = window.objectId;
  } else if (data.hasOwnProperty('object_id')) {
    request.objectId = data.object_id;
    delete data.object_id;
  } // IS PUBLIC


  if (data.hasOwnProperty('isPublic')) {
    request.isPublic = data.isPublic;
    delete data.isPublic;
  } // DATA (aside from reserved keywords)


  request.data = data;

  try {
    makeRequest('POST', "".concat(baseUrl, "/events/track"), request);
    return true;
  } catch (error) {
    console.log('ERROR:', error);
    return error;
  }
};

exports.count =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(data) {
    var request, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof data !== 'object')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", false);

          case 4:
            if (window.apiKey) {
              _context.next = 7;
              break;
            }

            retryCount(data);
            return _context.abrupt("return", false);

          case 7:
            request = {}; // WORKSPACE ID

            request.apiKey = window.apiKey; // USER ID (TRACKED USER)

            if (window.userId && !data.hasOwnProperty('user_id')) {
              request.trackedUser = window.userId;
            } else if (data.hasOwnProperty('user_id')) {
              request.trackedUser = data.user_id;
            } // OBJECT ID


            if (window.objectId && !data.hasOwnProperty('object_id')) {
              request.objectId = window.objectId;
            } else if (data.hasOwnProperty('object_id')) {
              request.objectId = data.object_id;
            } // TIMEFRAME


            if (data.hasOwnProperty('timeframe')) {
              request.timeframe = data.timeframe;
            } // EVENTS


            if (data.hasOwnProperty('events')) {
              request.events = data.events;
            }

            _context.prev = 13;
            _context.next = 16;
            return makeRequest('POST', "".concat(baseUrl, "/analyze/count"), request);

          case 16:
            response = _context.sent;
            return _context.abrupt("return", JSON.parse(response));

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](13);
            console.log('ERROR:', _context.t0);
            return _context.abrupt("return", _context.t0);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 20]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

function makeRequest(method, url, data) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      }
    };

    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };

    if (data) {
      xhr.send(JSON.stringify(data));
    } else {
      xhr.send();
    }
  });
}

function retryTrack(eventType, data) {
  setTimeout(function () {
    exports.track(eventType, data);
  }, 100);
}

function retryCount(data) {
  setTimeout(function () {
    exports.count(data);
  }, 100);
}